module.exports = __webpack_public_path__ + "static/img/statistics.97c5cdf0.png";